export default "__VITE_ASSET__DxjhR0hr__"